import React from 'react';
import { useSelector } from 'react-redux';
import Price from './Price';
import ActionButton from "./ActionButton";
import { useLingui } from '@lingui/react/macro';

function CartSumInfo({ onClick, inProgress }) {
    const cart = useSelector(state => state.cart);
    const isCartEmpty = useSelector(state => state.cart.nrExcursions === 0);

    const {t} = useLingui();

    return (
        <div className="text-right my-8">
            <Price
                largePreText={true}
                preText={t({id: "total_cost_of_your_planner"})}
                price={cart.totalPrice}
                currencySymbol={cart.currencySymbol}
            />

            <ActionButton
                onClick={onClick}
                disabled={isCartEmpty}
                classes="w-full mt-3 sm:px-6 sm:w-auto"
                buttonText={inProgress ? t({id: "please_wait"}) : t({id: "continue"})}/>
        </div>
    );
}

export default CartSumInfo;